import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram, Star } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" className="bg-obsidian text-ivory">
    <div className="container-luxe grid gap-14 py-20 lg:grid-cols-12 lg:py-28">
      <div className="lg:col-span-5">
        <img src="/images/logo-white.webp" alt="Scherif Real Estate" className="h-12 w-auto" loading="lazy" data-testid="footer-logo" />
        <p className="mt-6 font-mono text-[10px] uppercase tracking-[0.4em] text-champagne">Soby &amp; Associates</p>
        <p className="mt-8 max-w-sm font-serif text-2xl font-light leading-snug text-ivory/80">
          Exceptional real estate. Exceptional representation.
        </p>
        <p className="mt-6 flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.3em] text-ivory/50">
          <MapPin size={12} strokeWidth={1.5} aria-hidden="true" /> DC • Maryland • Virginia
        </p>
      </div>

      <div className="lg:col-span-2">
        <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Explore</p>
        <ul className="space-y-3">
          {[
            ["Home", "/"],
            ["Our Listings", "/listings"],
            ["List With Us", "/list-with-us"],
            ["Vacation Homes", "/vacation-homes"],
            ["About Us", "/about"],
            ["News", "/news"],
            ["Contact", "/contact"],
          ].map(([label, to]) => (
            <li key={to}>
              <Link to={to} data-testid={`footer-nav-${label.toLowerCase().replace(/\s+/g, "-")}`} className="link-underline text-sm text-ivory/70 hover:text-ivory">
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div className="lg:col-span-2">
        <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Legal</p>
        <ul className="space-y-3">
          <li>
            <Link to="/privacy-policy" data-testid="footer-nav-privacy" className="link-underline text-sm text-ivory/70 hover:text-ivory">
              Privacy Policy
            </Link>
          </li>
          <li>
            <Link to="/terms-and-conditions" data-testid="footer-nav-terms" className="link-underline text-sm text-ivory/70 hover:text-ivory">
              Terms &amp; Conditions
            </Link>
          </li>
        </ul>
      </div>

      <div className="lg:col-span-3">
        <p className="mb-6 font-mono text-[10px] uppercase tracking-[0.3em] text-champagne">Contact</p>
        <a href="tel:+12403724804" data-testid="footer-phone" className="flex items-center gap-3 text-sm text-ivory/80 transition-colors hover:text-champagne">
          <Phone size={14} strokeWidth={1.5} aria-hidden="true" /> 240-372-4804
        </a>
        <a
          href="mailto:Sobeida@realestatebyscherif.com"
          data-testid="footer-email"
          className="mt-4 flex items-center gap-3 break-all text-sm text-ivory/80 transition-colors hover:text-champagne"
        >
          <Mail size={14} strokeWidth={1.5} aria-hidden="true" /> Sobeida@realestatebyscherif.com
        </a>
        <a
          href="https://www.instagram.com/soldbysoby/"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          className="mt-4 flex items-center gap-3 text-sm text-ivory/80 transition-colors hover:text-champagne"
        >
          <Instagram size={14} strokeWidth={1.5} aria-hidden="true" /> @soldbysoby
        </a>
        <a
          href="https://maps.google.com/?cid=3715564280465972471"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-google"
          className="mt-4 flex items-center gap-3 text-sm text-ivory/80 transition-colors hover:text-champagne"
        >
          <Star size={14} strokeWidth={1.5} aria-hidden="true" /> Review Us on Google
        </a>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="container-luxe flex flex-col items-start justify-between gap-4 py-8 sm:flex-row sm:items-center">
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40">© 2026 Scherif Real Estate. All Rights Reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ivory/40">Equal Housing Opportunity</p>
      </div>
    </div>
  </footer>
);

export default Footer;
